export const EXPIRATION_DATE = "31/12/2026";
